import { render, staticRenderFns } from "./InformationNotice.vue?vue&type=template&id=02052a6c&"
import script from "./InformationNotice.vue?vue&type=script&lang=js&"
export * from "./InformationNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports